import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifyUser } from "../actions/auth.actions";
import {
  LOGIN_PAGE,
  SERVER_DOWN,
  SESSION_TOKEN_STORAGE_NAME,
} from "../Constants";

export default function ProtectedRoute({ children }) {
  const [renderComponent, setRenderComponent] = useState(children);

  const authenticateChildren = (subscriptionType, uiOnboardingLevel) => {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          isAuthenticated: true,
          subscriptionType: subscriptionType,
          uiOnboardingLevel: uiOnboardingLevel,
        });
      }
      return child;
    });
  };

  useEffect(() => {
    const isValidUser = async () => {
      const response = await verifyUser();

      if (!response) {
        console.log(SERVER_DOWN);
        return;
      }

      if (!response.data.success) {
        localStorage.removeItem(SESSION_TOKEN_STORAGE_NAME);
        setRenderComponent(
          <Navigate
            to={`${LOGIN_PAGE}?redirect_to=${window.location.pathname}`}
            replace
          />,
        );
      }
      if (response.data.success) {
        setRenderComponent(
          authenticateChildren(
            response.data.decodedAuthToken.subscription_type,
            response.data.decodedAuthToken.uiOnboardingLevel,
          ),
        );
      }
    };
    isValidUser();
  }, []);

  return renderComponent;
}
